export default "__VITE_ASSET__95689dfa__"